import { render } from "./instructor-filter.vue?vue&type=template&id=ed383794"
import script from "./instructor-filter.vue?vue&type=script&lang=js"
export * from "./instructor-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__